import { ApplicationRef, DoBootstrap, NgModule } from '@angular/core';

import { ApHeaderComponent } from '@ap/header';
import { GenericSkeletonComponent, PegaRetailModule } from '@ap/pega';

import { BaseStarterAppModule } from '../base-starter-app/base-starter-app.module';

import { StarterAppRetailComponent } from './starter-app-retail.component';
import { StarterAppRetailModuleUtils } from './starter-app-retail.module.utils';

@NgModule({
    imports: [ApHeaderComponent, BaseStarterAppModule, GenericSkeletonComponent, PegaRetailModule],
    exports: [BaseStarterAppModule, PegaRetailModule, StarterAppRetailComponent],
    declarations: [StarterAppRetailComponent]
})
export class StarterAppRetailModule implements DoBootstrap {
    public ngDoBootstrap(appRef: ApplicationRef): void {
        appRef.bootstrap(StarterAppRetailComponent);

        StarterAppRetailModuleUtils.setStarterAppInputs(appRef);
    }
}
